import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button } from "reactstrap";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AdminPageShell, { AdminSurface } from "../../../components/Admin/AdminPageShell";
import { getApiUrl, getMediaUrl } from "../../../utils/site";

const ProductManagement = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl("/api/products"), {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(response.data.data || response.data || []);
    } catch (error) {
      toast.error("Failed to fetch products.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteProduct = async (id) => {
    if (!window.confirm("Are you sure you want to delete this jewellery?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(getApiUrl(`/api/products/${id}`), {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Jewellery deleted successfully.");
      fetchProducts();
    } catch (error) {
      toast.error("Failed to delete jewellery.");
    }
  };

  return (
    <AdminPageShell
      eyebrow="Catalogue control"
      title="Products"
      description="Manage the jewellery catalogue, visual presentation, pricing, and stock from one cleaner workspace."
      actions={
        <Link to="/admin/products/add" className="roha-admin-navbar__chip roha-admin-navbar__chip--primary">
          Add product
        </Link>
      }
    >
      <AdminSurface
        title="Catalogue inventory"
        subtitle={`${products.length} jewellery items currently in the store`}
      >
        <div className="roha-admin-table-wrap">
          <Table responsive className="roha-admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Name</th>
                <th>Category</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Material</th>
                <th>Weight</th>
                <th>Size</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="11" className="roha-admin-empty">
                    Loading catalogue...
                  </td>
                </tr>
              ) : products.length ? (
                products.map((product, index) => (
                  <tr key={product.id}>
                    <td data-label="#">{index + 1}</td>
                    <td data-label="Image">
                      <img
                        src={getMediaUrl(product.image_url)}
                        alt={product.name}
                        className="roha-admin-image-thumb"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = "/image.jpg";
                        }}
                      />
                    </td>
                    <td data-label="Name">{product.name}</td>
                    <td data-label="Category">{product.category || "-"}</td>
                    <td data-label="Price">ETB {product.price}</td>
                    <td data-label="Stock">{product.stock_quantity}</td>
                    <td data-label="Material">{product.material || "-"}</td>
                    <td data-label="Weight">{product.weight || "-"}</td>
                    <td data-label="Size">{product.size || "-"}</td>
                    <td data-label="Status">
                      <span className="roha-admin-pill">{product.status || "active"}</span>
                    </td>
                    <td data-label="Actions">
                      <div className="roha-admin-toolbar">
                        <Link to={`/admin/products/edit/${product.id}`} className="roha-admin-navbar__chip">
                          Edit
                        </Link>
                        <Button color="danger" size="sm" onClick={() => handleDeleteProduct(product.id)}>
                          Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="roha-admin-empty">
                    No jewellery found yet.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </AdminSurface>
    </AdminPageShell>
  );
};

export default ProductManagement;
